import React from 'react';
import { string, shape, number } from 'prop-types';
import GoogleIcon from '../google-icon';

export default function ArticleTile({ item }) {
    return (
        <a
            href={item.url}
            title={item.title}
            className={`c-article-tile ${item.videoId && 'has-video'}`}
        >
            {item.thumbnail && (
                <div className="tile-image-wrapper">
                    <div
                        className="tile-image"
                        style={{ backgroundImage: `url(${item.thumbnail})` }}
                    >
                        <img src={item.thumbnail} alt={item.title} />
                    </div>
                </div>
            )}
            {item.videoId && (
                <div className="c-video-embed">
                    {item.videoHost === 'youtube' && (
                        <iframe
                            title={item.title}
                            data-lazy={true}
                            src={`https://www.youtube.com/embed/${item.videoId}?
                                rel=0&showinfo=0&color=white&autoplay=1&mute=1&loop=1&playlist=${item.videoId}`}
                            width="640"
                            height="360"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            allowFullScreen
                            style={{ border: '0' }}
                        />
                    )}

                    {item.videoHost === 'vimeo' && (
                        <iframe
                            title={item.title}
                            data-lazy={true}
                            src={`https://player.vimeo.com/video/${item.videoId}?autoplay=1&muted=1&loop=1`}
                            width="640"
                            height="360"
                            webkitallowfullscreen="true"
                            mozallowfullscreen="true"
                            allowFullScreen
                            style={{ border: '0' }}
                        />
                    )}
                </div>
            )}
            <div className="tile-content">
                <h3>{item.title}</h3>
                {item.paragraph && <p>{item.paragraph}</p>}
            </div>
            <div className="tile-links">
                <div>
                    {item.readTime && (
                        <div className="tile-detail">
                            <GoogleIcon icon="schedule" />
                            <span>{item.readTime}</span>
                        </div>
                    )}
                    <div className="tile-detail">
                        <GoogleIcon icon="calendar_today" />
                        <span>{item.date}</span>
                    </div>
                </div>
                <span className="read-more">Read more</span>
            </div>
        </a>
    );
}

ArticleTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        title: string.isRequired,
        timestamp: number.isRequired,
        thumbnail: string
    }).isRequired
    /* eslint-enable react/no-typos */
};
